<template>
  <div class="sticky-section-header"
       :class="{'sticky-section-header-fixed': isFixed}">
    <div class="container container-small">
      <AccentHeader
        :header="header"
        :underline="true"
        :uppercase="false"
      />
    </div>
  </div>
</template>

<script>
import AccentHeader from '@/components/AccentHeader.vue'

export default {
  name: 'sticky-section-header',
  props: ['header'],
  components: {
    AccentHeader
  },
  data: function () {
    return {
      headerTop: 0,
      ticking: false,
      isFixed: false,
      resizeTimer: 0
    }
  },
  methods: {
    handleScroll (event) {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          let scrollOffset = document.documentElement.scrollTop || document.body.scrollTop

          if (scrollOffset >= this.headerTop) {
            this.isFixed = true
          } else {
            this.isFixed = false
          }
          this.ticking = false
        })
        this.ticking = true
      }
    },
    handleResize () {
      clearTimeout(this.resizeTimer)
      this.resizeTimer = setTimeout(() => {
        this.headerTop = this.getStickySectionHeaderTopPosition()
        this.handleScroll()
      }, 250)
    },
    getStickySectionHeaderTopPosition () {
      const $el = this.$parent.$refs.stickySectionHeaderInit
      if (!$el) { return this.windowHeight }
      return Math.floor($el.offsetTop - 20)
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleResize)
  },
  updated () {
    this.handleResize()

    this.$nextTick(() => {
      this.handleResize()
    })
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped lang="scss">
.sticky-section-header {
  background: $body-bg;
  display: none;
  left: 0;
  padding-top: $gap-md;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  width: 100%;

  @include screen('md') {
    &-fixed {
      display: block;
      opacity: 1;
    } // END .sticky-section-header-fixed;
  }

} // END .sticky-section-header;
</style>
